import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import currencyFormat from 'src/utils/formatCOP';
import onMouseResultsMap from 'src/utils/onMouseResultsMap';
import { useStyles, StyledTableCell } from '../reportsBoard/styles';
import LoadingRows from './LoadingRows';

const TableAAA = ({ array = [], selectedDate }) => {
  const classes = useStyles();

  return (
    <>
      <TableContainer component={Paper}>
        <Table
          className={classes.table}
          size="small"
          aria-label="spanning table"
        >
          <TableHead>
            <TableRow>
              <StyledTableCell align="left">Mes</StyledTableCell>
              <StyledTableCell align="right">
                {selectedDate.getFullYear()}
              </StyledTableCell>
              <StyledTableCell align="right">
                {selectedDate.getFullYear() - 1}
              </StyledTableCell>
              <StyledTableCell align="right">
                {selectedDate.getFullYear() - 2}
              </StyledTableCell>
              <StyledTableCell align="center">AA</StyledTableCell>
              <StyledTableCell align="center">AAA</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {array.length > 0 ? (
              array.map((row) => (
                <TableRow key={Math.random()}>
                  <TableCell align="left">{row.MES}</TableCell>
                  <TableCell align="right">
                    {currencyFormat(parseInt(row.PERIODO1 || 0, 10))}
                  </TableCell>
                  <TableCell align="right">
                    {currencyFormat(parseInt(row.PERIODO2 || 0, 10))}
                  </TableCell>
                  <TableCell align="right">
                    {currencyFormat(parseInt(row.PERIODO3 || 0, 10))}
                  </TableCell>
                  <TableCell align="right">
                    {(+row.AA || 0 * 100).toFixed(2)}
                    %
                  </TableCell>
                  <TableCell align="right">
                    {(+row.AAA || 0 * 100).toFixed(2)}
                    %
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                  <TableCell><LoadingRows /></TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell>TOTAL</TableCell>
              <TableCell align="right">
                {onMouseResultsMap.totals(array, 'PERIODO1')}
              </TableCell>
              <TableCell align="right">
                {onMouseResultsMap.totals(array, 'PERIODO2')}
              </TableCell>
              <TableCell align="right">
                {onMouseResultsMap.totals(array, 'PERIODO3')}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TableAAA;
